import { gql } from '@apollo/client';

export const GET_OPS_HIERARCHY = gql(/* GraphQL */ `
    query GetOpsHierarchy(
        $includeClosedStores: Boolean
        $filterEmptyHierarchies: Boolean
    ) {
        getOperationsHierarchy(
            includeClosedStores: $includeClosedStores
            filterEmptyHierarchies: $filterEmptyHierarchies
        ) {
            director {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            seniorExecutive {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            opsAreas {
                id
                name
                executive {
                    id
                    firstName
                    lastName
                    email
                    faxNo
                    mobileNo {
                        dialingCode
                        countryCode
                        number
                    }
                    telNo {
                        dialingCode
                        countryCode
                        number
                    }
                    speedDial
                    designation
                }
                divisions {
                    id
                    name
                    regionalLocation
                    manager {
                        id
                        firstName
                        lastName
                        email
                        faxNo
                        mobileNo {
                            dialingCode
                            countryCode
                            number
                        }
                        telNo {
                            dialingCode
                            countryCode
                            number
                        }
                        speedDial
                        designation
                    }
                    stores {
                        id
                        name
                        boxNo
                        town
                        postCode
                        streetAddress
                        speedDial
                        storeNo
                        franchise
                        email
                        telNo {
                            dialingCode
                            countryCode
                            number
                        }
                        managers {
                            id
                            designation
                            firstName
                            lastName
                            speedDial
                            faxNo
                            telNo {
                                dialingCode
                                countryCode
                                number
                            }
                            mobileNo {
                                dialingCode
                                countryCode
                                number
                            }
                            email
                        }
                    }
                }
            }
        }
    }
`);

export const GET_USER_HIERARCHY = gql`
    query GetUserHierarchy($userId: String!) {
        getUserHierarchy(userId: $userId) {
            userId
            storeIds
            divisionIds
            opsAreaIds
        }
    }
`;
